import React, { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  getQuoteProGroupsAttributeApi,
  getQuoteProProductsBySearchCriteriaApi
} from 'api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import { useStyles } from 'pages//quotes/styles';


const EditQuoteListingsGroupSelect = ({ formik }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    quoteGroupsAttributeData,
    quoteProductsByGroup,
    quoteGroupsLoading,
    quoteProductsLoading
  } = useSelector((state: IReduxState) => state.quote);

  const loading = quoteGroupsLoading && quoteProductsLoading;

  const {
    values,
    setFieldValue,
    handleChange,
    handleBlur,
    errors,
    touched
  } = formik;

  const groups = useMemo(() => {
    return quoteGroupsAttributeData?.options?.filter((group) => group.value.length) || [];
  }, [quoteGroupsAttributeData]);

  useEffect(() => {
    if (!quoteGroupsAttributeData.options.length) {
      getQuoteProGroupsAttributeApi({ dispatch });
    }
  }, []);

  useEffect(() => {
    if (values.selectedGroup && !quoteProductsByGroup?.[values.selectedGroup]) {
      getQuoteProProductsBySearchCriteriaApi({
        dispatch,
        sortDirection: 'asc',
        sortField: 'name',
        pageSize: '',
        currentPage: '',
        filterConditions: [
          {
            field: 'catalog_quotepro_groups',
            value: `%${values.selectedGroup}%`,
            conditionType: 'like'
          },
          {
            field: 'status',
            value: '1',
            conditionType: 'eq'
          },
        ],
        searchConditions: []
      });
    }
  }, [values.selectedGroup]);

  const handleGroupChange = (event, group) => {
    const { items } = values;
    const updatedItems = items.map((item, index) => {
      if (!item.selectedItemGroup || (items.length - 1 === index)) {
        return {
          ...item,
          selectedItemGroup: group.value,
        };
      }

      return item;
    });

    setFieldValue('items', updatedItems);
    setFieldValue('selectedGroup', group.value);
    handleChange(event);
  };

  return (
    <Grid item xs={12} className="mr-2">
      <Typography variant="h6" className="mb-2">Select Group</Typography>
      <Autocomplete
        disableClearable
        onChange={(event, value) => handleGroupChange(event, value)}
        onBlur={handleBlur}
        options={groups}
        value={groups?.find((group) => group.value == values.selectedGroup) || null}
        getOptionLabel={(option) => option?.label}
        classes={{
          inputRoot: classes.autocompleteInput,
        }}
        size="small"
        loading={loading}
        fullWidth
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            name="selectedGroup"
            label="Select Group"
            error={touched.selectedGroup && !!errors.selectedGroup}
            helperText={touched.selectedGroup && errors.selectedGroup}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading && <CircularProgress color="inherit" size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Grid>
  );
};

export default EditQuoteListingsGroupSelect;
